import store from '../store'
import router from "../router"

export default {
  namespaced: true,
  state: {
    errors: [],
    token: '',
    currentUser: {}
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user
    },    
    setToken(state, token) {
      state.token = token;
    },
    setErrors(state, error) {
      if(error == 'clear') {
        state.errors = []
      } else {
        state.errors.push(error)
      }
    }
  },
  actions: {
    setCurrentUser({commit}, user) {
      commit('setCurrentUser', user)
    },    
    setToken({commit}, token) {
      commit('setToken', token)
    },
    setErrors({commit}, error) {
      commit('setErrors', error)
    }
  },
  getters: {
    currentUser(state) {
      return (Object.keys(state.currentUser).length === 0) ? undefined : state.currentUser
    },    
    getToken(state) {
      return state.token
    },
    getErrors(state) {
      return state.errors
    }
  }
}
